import { useEffect } from 'react'
import { SDrawerOrModal, STitle } from 'shj-components'
import { Button, Col, Form, Row, Spin } from 'antd'
import { useSetState } from 'ahooks'
import styles from './index.module.less'
interface IProps {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  dataInfo?: any // 回显数据
}
export default function Preview(prpos: IProps) {
  const [form] = Form.useForm()
  const { open, title, dataInfo, setOpen } = prpos
  const [state, setState] = useSetState<any>({
    loading: false,
    totalFee: 0,
    responseData: {},
    confirmLoading: false,
    secondData: [],
  })

  useEffect(() => {
    if (dataInfo && dataInfo?.transDetailList?.length) {
      let newArray: any = []
      dataInfo.transDetailList.map((item: any) => {
        newArray = [...newArray, ...item.receiptApplyDetailList]
      })
      setState({
        secondData: [...newArray],
      })
    }
  }, [dataInfo])

  return (
    <SDrawerOrModal
      title={title}
      mode="drawer"
      open={open}
      onCancel={() => setOpen(false)}
      width={500}
      antdProps={{
        footer: null,
      }}
    >
      {open && (
        <div>
          <Spin spinning={state.loading}>
            <STitle titleMode="string " title={'收款明细'} />
            <div className={styles.box}>
              <Row className={styles.confirmRow}>
                <Col span={12}>应收单类型</Col>
                <Col span={12}>应收金额</Col>
              </Row>
              {state.secondData?.map((item: any) => {
                return (
                  <Row className={styles.confirmRow}>
                    <Col span={12}>{item.receiptTypeName}</Col>
                    <Col span={12}>{item.needVerifiedAmount}</Col>
                  </Row>
                )
              })}
            </div>

            <STitle titleMode="string " title={'合计收款'} />
            <div className={styles.box}>
              <Row className={styles.confirmRow}>
                <Col span={12}>收款类型</Col>
                <Col span={12}>应收金额</Col>
              </Row>
              {dataInfo?.transDetailList?.map((item: any) => {
                return (
                  <Row className={styles.confirmRow}>
                    <Col span={12}>{item.transactionTypeName}</Col>
                    <Col span={12}>{item.amount}</Col>
                  </Row>
                )
              })}
            </div>
          </Spin>
        </div>
      )}
    </SDrawerOrModal>
  )
}
